import { generateReportPDF } from './pdf';

/**
 * Convert a record (object) into a single-section field list and download
 * a branded PDF. Use from RowActions onDownloadPdf on any list page.
 *
 *   downloadEntityPdf({
 *     title: 'Certificate · Civil Defence',
 *     subtitle: 'Compliance record',
 *     company,
 *     fields: [
 *       { label: 'Type', value: c.certificate_type },
 *       { label: 'Number', value: c.certificate_number },
 *       …
 *     ],
 *   })
 */
export function downloadEntityPdf({
  title,
  subtitle,
  company,
  fields = [],
  notes,
  filename,
  view = false,
  print = false,
}) {
  const rows = fields
    .filter(f => f.value !== undefined && f.value !== null && f.value !== '')
    .map(f => [f.label, String(f.value)]);

  const sections = [
    {
      heading: 'Details',
      head: ['Field', 'Value'],
      rows,
    },
  ];
  if (notes) sections.push({ heading: 'Notes', paragraph: notes });

  generateReportPDF({
    title,
    subtitle,
    company,
    sections,
    filename: filename || `${(title || 'record').toLowerCase().replace(/[^a-z0-9]+/g, '-')}.pdf`,
    view,
    print,
  });
}
